import script from "./BuyBanner.vue?vue&type=script&setup=true&lang=js"
export * from "./BuyBanner.vue?vue&type=script&setup=true&lang=js"

import "./BuyBanner.vue?vue&type=style&index=0&id=5cfc12ff&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cfc12ff"]])

export default __exports__